import React from "react";
import { DataTrending24Filled, DataTrending24Regular } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const PerfSpyAppLazy = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "PerfSpyV2" */ "./PerfSpyApp");
    return { default: namedExport.PerfSpyApp };
});

export const PerfSpy: TeamAppConfig = {
    title: "PerfSpy",
    regularIcon: DataTrending24Regular,
    filledIcon: DataTrending24Filled,
    description:
        "PerfSpy is the primary visualization tool for accessing EDS data. It is used almost always in triangulating any production issues in real-time.",
    team: "EDS",
    publicId: "M365EDS\\Triage",
    owner: "m365eds@microsoft.com",
    role: "*",
    tags: ["EDS - PerfSpy"],
    path: "/EDS/PerfSpyApp/perfspy",
    app: PerfSpyAppLazy
};
